<template>
  <div class="wrapper-map-images">
    <LadImage
      :style="customStyles"
      :src="`https://api.mapbox.com/styles/v1/mapbox/${style}/static/url-${market}(${center})/${center},${zoom}/${size}?access_token=${accessToken}`"
    />
  </div>
</template>

<script>
export default {
  name: 'LadMapImages',
  components: {
    LadImage: () =>
      import(
        /* webpackChunkName: "lad-image" */ '@/components/frontends/Image/index'
      ),
  },
  props: {
    center: { type: String, required: true, default: '0,0' },
    zoom: { type: Number, default: 12 },
    height: { type: String, default: '600px' },
    maxHeight: { type: String, default: '100vh' },
    size: { type: String, default: '1280x600' },
  },
  data() {
    return {
      style: 'outdoors-v10',
    }
  },
  computed: {
    accessToken() {
      return process.env.MAPBOX_API_KEY
    },
    customStyles() {
      return {
        height: this.height,
        maxHeight: this.maxHeight,
      }
    },
    market() {
      return encodeURIComponent(
        'https://cdn.localadventures.io/web-client/localadventures-50x50.png'
      )
    },
  },
}
</script>

<style lang="scss">
.wrapper-map-images {
  .lad-image {
    display: flex;
    flex-direction: row;
    flex: 1;
    width: 100%;
  }

  img {
    object-fit: cover;
    width: 100%;
  }
}
</style>
